import React, { useState, useEffect } from "react";
import { authServices } from "../../../../_services/Auth/AuthServices";
import styles from "./styles.module.css";
import tick from "../../../../assets/images/HomeView/tick_mark.png";
import DropDown from "../../../_common/DropDown/DropDown";
import { CommonApiService } from "../../../../_services";
import { Validation } from "../../../../_helpers/validation/Validation";

const GstScreen = (props) => {
  // const [registrationPage, setRegistrationPage] = useState(1);
  const [gst, setGst] = useState("");
  const [gstVerified, setGstVerified] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gstError, setGstError] = useState("");
  // const [gmailError, setGmailError] = useState("");
  const [isBusy, setIsBusy] = useState(true);
  // const [apiData, setApiData] = useState("");
  const [stateArray, setStateArray] = useState([]);
  const [state, setStates] = useState("");
  const [cityArray, setCityArray] = useState([]);
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const { apiPayload } = props;
    if (apiPayload && !gst) {
      setGst(apiPayload.gst);
      setGstVerified(true);
      setName(apiPayload.name);
      setEmail(apiPayload.email);
      setStates(apiPayload.state);
      setCity(apiPayload.city);
      setAddress(apiPayload.address);
      setPincode(apiPayload.pincode);
      getCity(apiPayload.state);
    }
  }, []);

  useEffect(() => {
    props.error?.email && setError(props.error);
  }, [props.error]);

  useEffect(() => {
    props.backRandom && setGstVerified(false);
  }, [props.backRandom]);

  useEffect(() => {
    getState();
  }, []);
  const getState = async () => {
    await CommonApiService.getStatesOfCountry().then((response) => {
      if (response && response.data && response.data.data)
        setStateArray(response.data.data);
    });
  };

  const onchangeState = (e) => {
    setCityArray([]);
    setCity("");
    setStates(e.value);
    getCity(e.value);
  };

  const getCity = (stateId) => {
    CommonApiService.getCityOfState(stateId).then((response) => {
      if (response && response.data && response.data.data)
        setCityArray(response.data.data);
    });
  };

  const gstVerify = async () => {
    if (gst) {
      if (gstVerified) {
        let data = {
          email: email,
          address: address,
          state: state,
          city: city,
          pincode: pincode,
        };
        let flag = 1;
        // let pincodeError = "";
        // let cityError = "";
        // let stateError = "";
        // let addressError = "";
        // if (email) {
        //   let regEmail =
        //     /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        //   if (regEmail.test(email) === false) {
        //     gmailErr = "Please enter valid email";
        //     flag = 0;
        //   }
        // }
        // if (!address) {
        //   addressError = "Please enter communication address";
        //   flag = 0;
        // }
        // if (!city) {
        //   cityError = "Please select city";
        //   flag = 0;
        // }
        // if (!state) {
        //   stateError = "Please select state";
        //   flag = 0;
        // }
        // if (!pincode) {
        //   pincodeError = "Please enter pincode";
        //   flag = 0;
        // }
        // let error = {
        //   address: addressError,
        //   pincode: pincodeError,
        //   city: cityError,
        //   state: stateError,
        //   gmail: gmailErr,
        // };
        // setError(error);
        let obj = Validation(data, rules);
        setError(obj);
        Object.keys(obj).forEach((index) => {
          if (obj[index] !== "") {
            flag = 0;
          }
        });
        if (flag) {
          let data = {
            gst: gst,
            name: name,
            address: address,
            pincode: pincode,
            city: city,
            state: state,
            email: email,
            // apiData: apiData,
          };
          props.pageChange(2, data);
        }
      } else {
        setIsBusy(false);
        let dataObj = {
          gstin_number: gst,
        };
        let response = await authServices.gstVerification(dataObj);
        setIsBusy(true);
        if (
          response?.data?.data?.success_status == "1" &&
          response?.data?.data?.name
        ) {
          setName(response?.data?.data?.name);
          setGstVerified(true);
          props.setVerified(true);
          setGstError("");
        } else {
          setGstError(response?.data?.message);
        }
      }
    } else {
      setGstError("Please enter GST number");
    }
  };
  return (
    <div>
      <div className="select-title">
        <b>User Type - BANK</b>
      </div>
      <div className="mt-3">
        <div className="">Enter your GST number</div>
        <div className="position-relative">
          {gstVerified && (
            <img
              src={tick}
              className={`position-absolute ${styles["tickCSS"]} ${styles["roiTop"]}`}
            />
          )}
          <input
            name="gst"
            type="text"
            // className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
            className={`poxinput ${
              gstVerified ? styles["paddingLeft32px"] : ""
            }`}
            id=""
            onChange={(e) => setGst(e.target.value)}
            // onKeyPress={onKeyPressSubmit}
            value={gst}
            required
            disabled={gstVerified}
            // readOnly={isAadhaarOrPan === ""}
          />
          {gstError && <div className="text-danger">{gstError}</div>}
        </div>
      </div>
      {gstVerified && (
        <>
          <div class="container mt-3">
            <div class="row">
              <div className={`col-3 ${styles["paddingUnset"]}`}>Name </div>
              <div className={`col-7 ${styles["paddingUnset"]}`}>{name}</div>
            </div>
          </div>
          {/* <div class="container">
            <div class="row">
              <div className={`col-3 ${styles["paddingUnset"]}`}>Address </div>
              <div
                className={`col-7 ${styles["paddingUnset"]} ${styles["textWrap2Lines"]}`}
              >
                {address}
              </div>
            </div>
          </div> */}
          <div className="mt-3">
            <div className="">Enter your email address</div>

            <input
              name="email"
              type="email"
              // className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
              className="poxinput"
              id=""
              onChange={(e) => setEmail(e.target.value)}
              // onKeyPress={onKeyPressSubmit}
              placeholder="Email address"
              value={email}

              // readOnly={isAadhaarOrPan === ""}
            />
            {error && error.email !== "" && (
              <div className="pb-4">
                <div className="fromerror w-75">{error.email}</div>
              </div>
            )}
          </div>

          <div className="form-group mt-4">
            <div className="poxlogin">
              <textarea
                name="first_name"
                style={{ minHeight: "87px" }}
                type="textarea"
                className={
                  error && error.address && error.address !== ""
                    ? "poxinput-error"
                    : "poxinput"
                }
                id=""
                // placeholder="Enter Village/Town Area"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
              {/* {error && error.address && error.address !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>} */}
              <label
                className={
                  error && error.address && error.address !== ""
                    ? "poxlabel-error"
                    : "poxlabel"
                }
              >
                Communication Address
              </label>
              {error && error.address !== "" && (
                <div className="fromerror">{error.address}</div>
              )}
            </div>
          </div>

          <div className="form-group mt-4">
            <div className="poxlogin">
              <input
                name="first_name"
                type="text"
                className={
                  error && error.pincode && error.pincode !== ""
                    ? "poxinput-error"
                    : "poxinput"
                }
                id=""
                // placeholder="Pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                required
              />
              {/* {error && error.pincode && error.pincode !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>} */}
              <label
                className={
                  error && error.pincode && error.pincode !== ""
                    ? "poxlabel-error"
                    : "poxlabel"
                }
              >
                Pincode
              </label>
              {error && error.pincode !== "" && (
                <div className="fromerror">{error.pincode}</div>
              )}
            </div>
          </div>

          <div className="sta-dis">
            {
              <div className="form-group mt-2 pologin twofield">
                <div
                  className={
                    error && error.state && error.state !== ""
                      ? "polabel-err"
                      : "polabel"
                  }
                >
                  State
                </div>
                {/* (panImage || ) ? */}
                {stateArray && (
                  <DropDown
                    preselected={state}
                    options={stateArray}
                    onChange={onchangeState}
                    className={
                      error && error.state && error.state !== ""
                        ? "polabelError"
                        : ""
                    }
                  />
                )}

                {error && error.state !== "" && (
                  <div className="fromerror">{error.state}</div>
                )}
              </div>
            }

            <div className="form-group mt-2 pologin twofield">
              <div
                className={
                  error && error.city && error.city !== ""
                    ? "polabel-err"
                    : "polabel"
                }
              >
                District
              </div>
              {cityArray && (
                <DropDown
                  preselected={city}
                  options={cityArray}
                  onChange={(e) => setCity(e.value)}
                  className={
                    error && error.city && error.city !== ""
                      ? "polabelError"
                      : ""
                  }
                />
              )}

              {error && error.city !== "" && (
                <div className="fromerror">{error.city}</div>
              )}
            </div>
          </div>
        </>
      )}
      {/* {error?.buyerSeller && (
              <div className="fromerror">{error.buyerSeller}</div>
            )} */}
      <div className="mt-4">
        <a
          href="javascript:void(0)"
          className="form-control posubmit"
          style={{
            backgroundColor: "#e08701",
            textAlign: "center",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer",
          }}
          onClick={() => (isBusy ? gstVerify() : "")}
        >
          Continue
        </a>
      </div>
    </div>
  );
};

export default GstScreen;
const rules = [
  {
    field_name: "email",
    label: "Email",
    type: "email",
    isRequired: false,
  },
  {
    field_name: "pincode",
    label: "Pincode",
    type: "number",
    min: 6,
    max: 6,
    isRequired: true,
  },
  {
    field_name: "city",
    label: "city",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "state",
    label: "State",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "address",
    label: "Communication Address",
    type: "string",
    isRequired: true,
  },
];
